
import React from "react";
import LeftSidebar from "../LeftSidebar/LeftSidebar";
import Integrations from "./Integrations";


function MainScreen() {
    return (
        <div className="max-w-8xl mx-auto grid grid-cols-1 lg:grid-cols-8">
            <LeftSidebar />
            <div className="lg:col-span-7 lg:px-8 lg:pr-[3.5rem]">
                <Integrations />
            </div>
        </div>
    );
}

export default MainScreen;
